function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("path", {
  d: "M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751 c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0 c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"
}));

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null);

const SvgDownArrow = (_ref) => {
  let {
    svgRef,
    ...props
  } = _ref;
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "Capa_1",
      x: "0px",
      y: "0px",
      width: "451.847px",
      height: "451.847px",
      viewBox: "0 0 451.847 451.847",
      style: {
        enableBackground: "new 0 0 451.847 451.847"
      },
      xmlSpace: "preserve",
      ref: svgRef
    }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17)
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgDownArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/down-arrow.7da2026c.svg";
export { ForwardRef as ReactComponent };